import { CheckboxOptionType } from 'antd';
import { useMetricBuilderStore } from '../../store';
import { EMetricTypes } from '@src/emp-3.0/types';

export enum EGetMetricWay {
  existing_metric = 'existingMetric',
  build_from_event = 'buildFromEvent',
  fixed_number = 'fixedNumber',
}
export type MetricRole = 'numerator' | 'denominator';

export const getMetricOptions: CheckboxOptionType<EGetMetricWay>[] = [
  {
    value: EGetMetricWay.existing_metric,
    label: 'Existing Metric',
  },
  {
    value: EGetMetricWay.build_from_event,
    label: 'Build from Event',
  },
];

export interface GetMetricProps {
  used_metric_id?: number;
  is_numerator_filter_enabled?: boolean;
  event?: number;
  calculation?: string;
  attribute?: string;
  attribute_type?: number;
  fixed_number?: number;
}

export interface RatioMetricInfo {
  name: string;
  description: string;
  metrics_type: EMetricTypes.RATIO_METRIC;
  definition: {
    numerator: GetMetricProps;
    denominator: GetMetricProps;
    unit: string;
    is_higher_better: boolean;
  };
}

export function useGetEventToEdit(metricRole: MetricRole) {
  const { numeratorEvent, setNumeratorEvent, denominatorEvent, setDenominatorEvent } =
    useMetricBuilderStore();
  const eventToEdit = metricRole === 'numerator' ? numeratorEvent : denominatorEvent;
  const setEventToEdit = metricRole === 'numerator' ? setNumeratorEvent : setDenominatorEvent;
  return { eventToEdit, setEventToEdit };
}
